import { render, staticRenderFns } from "./latestNews.vue?vue&type=template&id=cc231ce2&scoped=true"
import script from "./latestNews.vue?vue&type=script&lang=js"
export * from "./latestNews.vue?vue&type=script&lang=js"
import style0 from "./latestNews.vue?vue&type=style&index=0&id=cc231ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc231ce2",
  null
  
)

export default component.exports